import { propArray } from '@rxweb/reactive-forms'
import TakedownForm from '~/models/forms/takedownForm'

export default class TakedownsForm {
  @propArray() takedowns: TakedownForm[] = []
}
